module.exports = __webpack_public_path__ + "images/dingtalk/init-completed-4cd79daa34332ecdb1068664ef8a4522.png";